import TopBar from '../components/TopBar';
import { Box, Typography, useTheme, IconButton } from '@mui/material';
import { tokens } from "../theme";
import { fetchProducts } from '../utils/apiHelpers';
import { useEffect, useState } from 'react';
import React from 'react'
import StoreProduct from '../components/StoreProduct';

import ShopIcon from '@mui/icons-material/ShoppingCart';

import styles from './Store.module.css'; 

import { useAuth } from '../components/AuthProvider';

import api from '../utils/api';

function Store() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [menuOpen, setMenuOpen] = React.useState(false);

  // Functions as a shopping cart, initialized as all products in the store
  // with an amount of 0
  const [products, setProducts] = useState([]);
  const { user } = useAuth();

  // Call this to add a product to the shopping cart
  const addProduct = (productToAdd, value) => {
    console.log(value);
    setProducts(prevProducts => {
      return prevProducts.map(item => {
        if (item.id === productToAdd.id) {
          return { ...item, amount: item.amount + value < 0 ? 0 : item.amount + value };
        }
        return item;
      })
    });
  };

  async function handlePurchase() {
      const cartItems = products.filter(p => p.amount > 0);

      setMenuOpen(true)

      setTimeout(() => {
        setMenuOpen(false);
      }, 3000);

      const cart = {
        products: cartItems.map(product => ({ 
            ...product, 
            user_id: user.id, 
            date: new Date()
        }))
      };
      console.log(cart)
      try {
          await api.post('/create_transactions', cart);
          // Reset the cart after purchase
          setProducts(prevProducts => {
            return prevProducts.map(item => ({ ...item, amount: 0 }));
          });
      } catch (err) {
          console.log(err)
      }
  }

  function getTotalPrice() {
    let totalPrice = 0;
    products.forEach(item => {
      totalPrice += item.amount * item.price
    })
    return totalPrice;
  };

  useEffect(() => {
    fetchProducts()
      .then(data => setProducts(data.map(product => ({ ...product, amount: 0 }))))
      .catch(err => console.log(err));
  }, []);

  return (
    <div style={{ height: "100vh", display: "flex", flexDirection: "column" }}>
      <TopBar/>
      <Box display="flex" flexDirection="column" justifyContent="flex-start" rowGap="5px">
        <Typography
          variant="h2"
          color={colors.ceriseAccent[900]}
          fontWeight="medium" 
          sx={{m : "50px 0 30px 30px" }}
          >
          Baxshoppen
        </Typography>
      </Box>
      <Box display="flex" justifyContent="space-around" flexWrap="wrap" sx={{m : "0 30px 10px 30px" }}>
        {
          products !== undefined ?
          products
            .filter((product) => product.active === 1)
            .map((product) => {
              console.log(product)
              return (
                <StoreProduct
                product={product}
                onRemoveFromCart={() => {
                  addProduct(product, -1);
                }}
                onAddToCart={() => {
                  addProduct(product, 1);
                }}
                />
              )
            })
            : null
        }
      </Box>

      {/* Button for paying that also displays shopping cart total */}
      {
      getTotalPrice() > 0 ?
      <Box className={styles.modalPay}
      >
        <Box display="flex" width="100%" component="button" onClick={handlePurchase}
        sx={{ backgroundColor: colors.ceriseAccent[100], padding: 2, borderRadius: 2, border: "none" }}>
          <Box display="flex" justifyContent="flex-start" alignItems="center" width="100%">
            <ShopIcon sx={{fontSize: 32, color: colors.gray[100]}}/>
            <Typography
              variant="h3"
              color={colors.gray[100]}
              fontWeight="medium" 
              >
              Strecka
            </Typography>
          </Box>
          <Box display="flex" justifyContent="flex-end" alignItems="center" width="50%">
            <Typography
              variant="h3"
              color={colors.gray[100]}
              fontWeight="medium" 
              >
              {getTotalPrice()} kr
            </Typography>
          </Box>
        </Box>
      </Box>
      : null
      }

      {/* Announcement when payment is done */}
      <Box className={`${styles.modal} ${menuOpen ? styles.modalOpen : ''}`}>
        <Box display="flex" alignItems="center" justifyContent="center" padding="10px" sx={{bgcolor: colors.ceriseAccent[100], borderRadius: "4px"}}>
            <Typography
                variant="h4"
                color={colors.gray[100]}
                fontWeight="medium" 
                >
              Streckning genomfördes!
            </Typography>
        </Box>
      </Box>
    </div>
  )
}

export default Store;